export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 2-2_13.42b3722f.jpg";